import { createFileRoute } from '@tanstack/react-router'
import { SummarizationContainer } from '../../../components/Summarization'
import { ActionBar } from '../../../components/ActionBar'

export const Route = createFileRoute('/_authenticated/summarizations/')({
  component: SummarizationsPage,
})

function SummarizationsPage() {
  return (
    <>
      <ActionBar title="URL Summarizations" />
      <div className="flex flex-col p-4">
        <SummarizationContainer />
      </div>
    </>
  )
}
